import { useEffect } from 'react'
import { Storage } from 'aws-amplify'

/**
 * Hook that alerts clicks outside of the passed ref
 */
export const useOutsideAlerter = (ref, setIsNewFolderPopupVisible) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        // ignores the actions of the buttons that the pop up opened on top of it

        setIsNewFolderPopupVisible(false)
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref])
}

export const createFolder = async (cwd, folderName) => {
  const result = await Storage.put(cwd + folderName, `${folderName}`, {
    level: 'public',
    contentType: 'text/plain',
  })
}
